import * as types from '../types/reviewTypes';

function slugKey(slugOrId) {
  return String(slugOrId || '').trim().toLowerCase();
}

const initialState = {
  bySlug: {},
  overview: {
    loading: false,
    error: null,
    summary: { average: 0, count: 0 },
    reviews: [],
  },
};

const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRODUCT_REVIEWS_REQUEST: {
      const slug = slugKey(action.payload?.slug);
      if (!slug) return state;
      return {
        ...state,
        bySlug: {
          ...state.bySlug,
          [slug]: {
            ...(state.bySlug[slug] || {}),
            loading: true,
            error: null,
          },
        },
      };
    }
    case types.FETCH_PRODUCT_REVIEWS_SUCCESS: {
      const { slug, reviews, summary } = action.payload || {};
      const key = slugKey(slug);
      if (!key) return state;
      return {
        ...state,
        bySlug: {
          ...state.bySlug,
          [key]: {
            loading: false,
            error: null,
            reviews,
            summary,
          },
        },
      };
    }
    case types.FETCH_PRODUCT_REVIEWS_FAILURE: {
      const slug = slugKey(action.payload?.slug);
      if (!slug) return state;
      return {
        ...state,
        bySlug: {
          ...state.bySlug,
          [slug]: {
            ...(state.bySlug[slug] || {}),
            loading: false,
            error: action.payload?.message ?? 'Failed',
            reviews: state.bySlug[slug]?.reviews ?? [],
            summary: state.bySlug[slug]?.summary ?? null,
          },
        },
      };
    }

    case types.FETCH_REVIEWS_OVERVIEW_REQUEST:
      return {
        ...state,
        overview: { ...state.overview, loading: true, error: null },
      };
    case types.FETCH_REVIEWS_OVERVIEW_SUCCESS:
      return {
        ...state,
        overview: {
          loading: false,
          error: null,
          summary: action.payload?.summary ?? { average: 0, count: 0 },
          reviews: action.payload?.reviews ?? [],
        },
      };
    case types.FETCH_REVIEWS_OVERVIEW_FAILURE:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: false,
          error: action.payload ?? null,
        },
      };

    default:
      return state;
  }
};

export default reviewReducer;
